import React from "react";

import { Nav } from "components/Nav";
import { Page } from "components/Page";

export const PageWithNav = ({ children }) => {
  return (
    <Page>
      <Nav />
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="container p-4">{children}</div>
      </div>
    </Page>
  );
};
